<template>
  <g>
    <defs>
      <path
        id="no-report@1x-a"
        d="M9.44343361,7.3 C9.80043361,6.945 10.3994336,6.951 10.7424336,7.3 C10.9194336,7.477 11.0134336,7.708 11.0124415,7.952 C11.0114336,8.197 10.9154336,8.427 10.7414336,8.598 L10.7414336,8.598 L9.08943361,10.244 L10.7414336,11.89 C10.9194336,12.067 11.0134336,12.298 11.0124415,12.542 C11.0114336,12.787 10.9154336,13.016 10.7414336,13.188 C10.5644336,13.364 10.3364336,13.458 10.0934336,13.458 L10.0934336,13.458 L9.97188268,13.4500787 C9.77204472,13.4238056 9.58760027,13.3328333 9.44343361,13.187 L9.44343361,13.187 L7.79843361,11.535 L6.15243361,13.187 C5.79543361,13.542 5.19843361,13.5359952 4.85343361,13.187 C4.67743361,13.01 4.58243361,12.779 4.58342579,12.535 C4.58443361,12.291 4.68043361,12.061 4.85443361,11.89 L4.85443361,11.89 L6.50743361,10.244 L4.85343361,8.598 C4.49543361,8.24 4.49543361,7.658 4.85343361,7.3 C5.20043361,6.952 5.80543361,6.953 6.15243361,7.299 L6.15243361,7.299 L7.79843361,8.952 Z M7.79463361,-1.02140518e-13 C9.96363361,-1.02140518e-13 11.9276336,1.272 12.8166336,3.247 C14.4516336,3.763 15.5906336,5.307 15.5956375,7.026 C15.5976336,8.439 14.8386336,9.759 13.6156336,10.469 C13.4766336,10.549 13.3186336,10.591 13.1586336,10.591 C12.8316336,10.591 12.5256336,10.414 12.3626336,10.13 C12.2406336,9.918 12.2086336,9.671 12.2726336,9.434 C12.3366336,9.197 12.4886336,9 12.7016336,8.878 C13.2336336,8.56 13.6026336,8.028 13.7126336,7.418 C13.8156336,6.853 13.6916336,6.284 13.3646336,5.813 C13.0386336,5.343 12.5476336,5.027 11.9836336,4.925 C11.6516336,4.868 11.3786336,4.633 11.2716336,4.311 C10.7646336,2.831 9.37063361,1.833 7.80363361,1.83 C5.77363361,1.83 4.12563361,3.475 4.12063361,5.496 C4.12063361,6.001 3.71063361,6.412 3.20563361,6.412 C2.44463361,6.412 1.82563361,7.03 1.82563361,7.791 C1.84263361,8.356 2.20063361,8.85 2.73663361,9.043 C3.21263361,9.116 3.55663361,9.591 3.47663361,10.095 C3.40363361,10.546 3.01963361,10.874 2.56363361,10.874 C2.51563361,10.874 2.46663361,10.87 2.41763361,10.862 C2.33863361,10.864 2.24563361,10.848 2.15163361,10.819 C1.11763361,10.455 0.349633606,9.607 0.0916336061,8.548 C-0.319366394,6.862 0.690633606,5.156 2.35163361,4.695 C2.63063361,2.83 3.86763361,1.213 5.59963361,0.459 C6.29963361,0.154 7.03763361,-1.02140518e-13 7.79463361,-1.02140518e-13 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode: color-burn"
      />
      <use
        :fill="currentColor"
        :opacity="opacity"
        xlink:href="#no-report@1x-a"
        transform="translate(4 4)"
      />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>